<template>
  <el-dialog
    :title="titleName"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="30%"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <div class="left">
        <el-form :model="formInline" ref="form" :rules="rules">
          <el-form-item label="数据源名称" prop="ruleTable">
            <el-input
              v-model="formInline.ruleTable"
              placeholder="请输入数据源名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="checkRole('GLLD')"
            label="主办部门"
            prop="tjDeptId"
          >
            <el-select v-model="formInline.tjDeptId" placeholder="请选择">
              <el-option
                v-for="item in deptList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文件" prop="file">
            <br />
            <el-upload
              class="upload-demo"
              accept=".xlsx"
              action="#"
              :auto-upload="false"
              :show-file-list="true"
              :on-change="importDataFun"
              :on-remove="() => (formInline.file = '')"
            >
              <el-button class="other el-icon-upload2">数据导入</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="addOrUpdateFun" :loading="saving"
        >保 存</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { extendGglrRkEdit } from "@/api/task.js";
import commonTable from "@/components/table/index.vue";
import pageChangeSelect from "@/mixins/page-change-select.js";
import { importExtendClRk } from "@/api/base.js";
import { getDeptTree } from "@/api/systemManagement.js";
export default {
  components: {
    commonTable
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    },
    titleName: {
      type: String,
      defalut: "新增"
    },
    commcommunityList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  mixins: [pageChangeSelect],
  data() {
    return {
      deptList: [],
      saving: false,
      formInline: {
        ruleTable: "",
        file: "",
        tjDeptId: ""
      },
      rules: {
        tjDeptId: [
          {
            required: true,
            message: "请选择部门",
            trigger: ["blur", "change"]
          }
        ],
        ruleTable: [
          {
            required: true,
            message: "请输入数据源",
            trigger: ["blur", "change"]
          }
        ],
        file: [
          {
            required: true,
            message: "请上传文件",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  // watch: {
  //   curItem(val) {
  //     this.formInline = val;
  //   }
  // },
  // mounted() {
  //   this.formInline = this.curItem;
  // },
  created() {
    this.getTree();
  },
  methods: {
    async getTree() {
      let params = {
        page: 999,
        size: 1,
        pid: "2000000035",
        data: true
      };
      const res = await getDeptTree(params);
      if (res.data.code == 200) {
        this.deptList = res.data.data;
      }
    },
    checkRole(roleCode) {
      try {
        const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        const role = userInfo.roles.find(role => role.roleCode === roleCode);
        return role ? true : false;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    getDeptId() {
      try {
        const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        return userInfo.deptId;
      } catch (error) {
        console.error(error);
        return "";
      }
    },
    // 数据导入
    async importDataFun(file) {
      this.formInline.file = "";
      if (!file.name.endsWith(".xlsx")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.xlsx",
          type: "warning"
        });
        return;
      }
      this.formInline.file = file;
    },
    async handleUpload() {
      let formData = new FormData();
      formData.append("file", this.formInline.file.raw);
      formData.append("ruleTable", this.formInline.ruleTable);
      formData.append("zbDeptId", this.formInline.tjDeptId || this.getDeptId());
      const res = await importExtendClRk(formData);
      return res;
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async addOrUpdateFun() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          this.saving = true;
          let res = await this.handleUpload().finally(
            () => (this.saving = false)
          );
          console.log(res, 9999);
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.handleClose();
            this.$emit("refreshList");
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        }
      });
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
@import "~@/components/less.less";
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
  overflow: hidden;
}
.container-dialog {
  overflow: hidden;
  display: flex;
  .left {
    width: 100%;
    // height: 200px;
    overflow: auto;
    margin-right: 24px;
  }
}

/deep/ .specialForm {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/baseInfo/customEvent/components/addDialog2.vue